import React from "react";
import { Link } from "react-router-dom";

interface TitleProps {
  title: string;
  className?: string;
  link?: string;
  ball?: boolean;
}

const Title: React.FC<TitleProps> = ({ title, className, link, ball }) => {
  return (
    <div className="mr-2 pr-2">
      <Link to={link || ""}>
        <div
          className={`text-start mb-3 text-3xl max-md:text-3xl ${className} font-extrabold text-Secondary`}
        >
          {title}
        </div>
      </Link>
    </div>
  );
};

export default Title;
